module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/give_your_career-78872185bb7bc66a1d8c0db0be6b2aa4.svg";